import type { Document } from '@features/documents/api/types/document.types';

export function getLocationName(document: Document): string {
  const { parentFolders } = document;
  if (parentFolders.length === 0) return '';
  return parentFolders[parentFolders.length - 1].name;
}
